const getPicturesNumber = (pictureurl) => {
  if (!pictureurl) return undefined
  return Number(pictureurl.substring(pictureurl.indexOf('#') + 1))
}

export const getUrlWithCorrectProtocol = (pictureurl) => {
  const pictureValue = pictureurl.replace(/^https?:\/\//i, '')
  return `${window.location.protocol}//${pictureValue}`
}

const getPictures = (pictureurl) => {
  if (!pictureurl) return undefined

  const url = getUrlWithCorrectProtocol(pictureurl)
  const picturesNumber = getPicturesNumber(url) || 50
  if (url.includes('fotoeoc.arval.it/GeritDocs')) {
    const pointPath = url.split('.')
    const ext = pointPath.pop()
    const basePicture = pointPath.join('.').slice(0, -4)
    const result = []
    for (let i = 0; i < picturesNumber; i++) {
      const codeValue = `${i + 1}`.padStart(4, 0)
      const currentPicture = `${basePicture}${codeValue}.${ext}`
      result.push({ original: currentPicture, thumbnail: currentPicture })
    }
    return result
  } else {
    const pointPath = url.split('.')
    const ext = pointPath.pop().split('#').shift()
    const tokens = url.split('/')
    tokens.pop()
    const basePicture = tokens.join('/')
    const result = []
    for (let i = 0; i < picturesNumber; i++) {
      const codeValue = `${i + 1}`.padStart(2, 0)
      const currentPicture = `${basePicture}/${codeValue}.${ext}`
      result.push({ original: currentPicture, thumbnail: currentPicture })
    }

    return result
  }
}

export default getPictures
